export default __webpack_public_path__ + "static/cool-guy-b2e8453fdfa1e130c5ca9b12f8acf9f1.jpg";